import { Placeholder, Card } from "react-bootstrap";

const JobCardPlaceholder = () => {
    return (
        <Card className="mb-3 p-3 d-flex flex-row align-items-center">
            {/* Company Logo */}
            <div className="me-3">
                <Placeholder
                    as="div"
                    animation="glow"
                    className="rounded"
                    style={{ width: 60, height: 60 }}
                />
            </div>

            {/* Job Content */}
            <div className="flex-grow-1">
                <Placeholder as="h5" animation="glow">
                    <Placeholder xs={4} />
                </Placeholder>

                <Placeholder as="h4" animation="glow">
                    <Placeholder xs={6} />
                </Placeholder>

                <Placeholder as="p" animation="glow">
                    <Placeholder xs={10} /> <Placeholder xs={8} />
                </Placeholder>
            </div>

            <div className="ms-3">
                <Placeholder as="p" animation="glow">
                    <Placeholder xs={5} /> <Placeholder xs={8} />
                </Placeholder>
                <Placeholder.Button
                    animation="glow"
                    style={{ width: "115px", height: "40px", backgroundColor: "#404040ff" }}
                />
            </div>
        </Card>
    );
};

export default JobCardPlaceholder;
